import { Icon, IconProps } from "../";

export const EditIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M19.1622 8.40914L15.5745 4.85415L16.9707 3.4579C17.276 3.15263 17.6522 3 18.0992 3C18.5462 3 18.9223 3.15263 19.2276 3.4579L20.5421 4.77238C20.8474 5.07765 21.0054 5.44834 21.0163 5.88445C21.0272 6.32056 20.8801 6.69125 20.5748 6.99652L19.1622 8.40914ZM18.0092 9.57845L6.58767 21H3V17.4123L14.4215 5.99075L18.0092 9.57845Z" />
    </Icon>
  );
};
